import {
  TDashboardConfigSettingsSearch,
  TDashboardConfigSettingsSearchGroup,
} from '@/store/models/dashboard-config.model';

export interface ISearchFormFields {
  search?: string;
  type?: {
    value: TDashboardConfigSettingsSearch;
    group: TDashboardConfigSettingsSearchGroup;
  };
}

export type TSearchGroup = Record<
  TDashboardConfigSettingsSearchGroup,
  { value: TDashboardConfigSettingsSearch; isDisabled: boolean }[]
>;

export const SEARCH_GROUP: Record<TDashboardConfigSettingsSearchGroup, TDashboardConfigSettingsSearch[]> = {
  user: ['userId', 'userTag', 'userName', 'email'],
  wallet: ['walletId', 'walletIban'],
  card: ['cardToken', 'cardEmbossedName'],
  beneficiary: ['beneficiaryId', 'beneficiaryIban', 'beneficiaryName'],
} as const;

export const NUMERIC_FIELDS: TDashboardConfigSettingsSearch[] = [
  'userId',
  'walletId',
  'cardToken',
  'beneficiaryId',
  'userTag',
] as const;

export const LETTER_FIELDS: TDashboardConfigSettingsSearch[] = [
  'userTag',
  'beneficiaryName',
  'cardEmbossedName',
  'userName',
] as const;

export const IBAN_FIELDS: TDashboardConfigSettingsSearch[] = ['beneficiaryIban', 'walletIban'] as const;
